// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_logo__JuMzO {
  width: 35px;
  margin-bottom: 24px;
}
@media (min-width: 768px) {
  .styles_logo__JuMzO {
    width: 53px;
    margin-bottom: 16px;
  }
}

.styles_pageHeader__-LN-j {
  text-align: center;
}

.styles_pageTitle__d8RTU {
  font: var(--typography-h2);
}
@media (min-width: 768px) {
  .styles_pageTitle__d8RTU {
    font: var(--typography-h1);
  }
}

.styles_pageSubtitle__gcP57 {
  font: var(--typography-body-m-regular);
  color: var(--color-text-secondary);
  margin: 16px auto 0;
}

.styles_stepIndicator__-Qtqq {
  margin-top: 16px;
  font: var(--typography-body-m-medium);
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/components/page-header/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,mBAAA;AAAF;ACIE;EDNF;IAKI,WAAA;IACA,mBAAA;EACF;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,0BAAA;AACF;ACVE;EDQF;IAII,0BAAA;EAEF;AACF;;AACA;EACE,sCAAA;EACA,kCAAA;EACA,mBAAA;AAEF;;AACA;EACE,gBAAA;EACA,qCAAA;EACA,yBAAA;AAEF","sourcesContent":["@import \"mixins\";\n.logo {\n  width: 35px;\n  margin-bottom: 24px;\n\n  @include md {\n    width: 53px;\n    margin-bottom: 16px;\n  }\n}\n\n.pageHeader {\n  text-align: center;\n}\n\n.pageTitle {\n  font: var(--typography-h2);\n\n  @include md {\n    font: var(--typography-h1);\n  }\n}\n\n.pageSubtitle {\n  font: var(--typography-body-m-regular);\n  color: var(--color-text-secondary);\n  margin: 16px auto 0;\n}\n\n.stepIndicator {\n  margin-top: 16px;\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n}","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `styles_logo__JuMzO`,
	"pageHeader": `styles_pageHeader__-LN-j`,
	"pageTitle": `styles_pageTitle__d8RTU`,
	"pageSubtitle": `styles_pageSubtitle__gcP57`,
	"stepIndicator": `styles_stepIndicator__-Qtqq`
};
export default ___CSS_LOADER_EXPORT___;
